module.exports = __webpack_public_path__ + "img/arrow_up.935c9ec0.svg";